/* istanbul ignore file */
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import EmployeesBreadcrumbs from 'domain/people/employee/shared/EmployeesBreadcrumbs';

const CreateEmployeeBreadcrumbs = () => {
  return (
    <EmployeesBreadcrumbs>
      <CreateBreadcrumbItem entity="Worker" />
    </EmployeesBreadcrumbs>
  );
};

export default CreateEmployeeBreadcrumbs;
